import React, { useMemo, useState } from "react";
import { Section } from "../ui/Section";
import { Field } from "../ui/Field";
import { MultiSelectChips } from "../ui/MultiSelectChips";
import styles from "../../styles/evento-form.module.css";
import EnlacesField from "../../../../components/EnlacesField";

export function StepDatos({ form, setField, setForm, personas, files, setFiles }) {
    const agentesOptions = useMemo(() => {
        return (personas || [])
            .filter((p) => p?.tipoPersona === "AGENTE")
            .map((p) => ({ value: p.id, label: `${p.nombre} ${p.apellidos}` }));
    }, [personas]);



    return (
        <Section>
            <div className={styles["grid-3"]}>
                <Field label="Nombre del evento" required>
                    <input
                        type="text"
                        value={form.nombre}
                        onChange={(e) => setField("nombre", e.target.value)}
                        placeholder="Nombre del evento"
                    />
                </Field>

                <Field label="Fecha de inicio">
                    <input
                        type="date"
                        value={form.fechaInicio}
                        onChange={(e) => setField("fechaInicio", e.target.value)}
                    />
                </Field>

                <Field label="Fecha de fin">
                    <input
                        type="date"
                        value={form.fechaFin}
                        onChange={(e) => setField("fechaFin", e.target.value)}
                    />
                </Field>
            </div>

            <Field
                label="Agente(s)"
                hint="Opcional. Máximo 2 agentes. No cuentan como participantes."
            >
                <MultiSelectChips
                    options={agentesOptions}
                    value={form.agenteIds || []}
                    onChange={(vals) => {
                        if ((vals?.length || 0) > 2) alert("Solo puedes elegir hasta 2 agentes.");
                        const next = Array.isArray(vals) ? vals.slice(0, 2) : [];
                        setField("agenteIds", next);
                    }}
                    placeholder="Buscar agente..."
                    hideSelected={false}
                />
            </Field>

            <div className={styles["grid-1"]}>
                <Field label="Observación">
                    <textarea
                        value={form.descripcion}
                        onChange={(e) => setField("descripcion", e.target.value)}
                        placeholder="Escribe aquí las observaciones del evento"
                    />
                </Field>
            </div>

            <div className={styles["grid-2"]} style={{ marginTop: "1rem" }}>
                <Field label="Evento provisional (reserva)">
                    <label className={styles.checkbox}>
                        <input
                            type="checkbox"
                            checked={form.esProvisional}
                            onChange={(e) => setForm((prev) => ({ ...prev, esProvisional: e.target.checked }))}
                        />
                        Marcar como provisional (no definitivo)
                    </label>
                </Field>

                <Field label="Documento del evento (PDF/imagen)">
                    <div className={styles["file-row"]}>
                        <div className={styles["file-control"]} style={{ flex: 1 }}>
                            <input
                                className={styles["file-input"]}
                                type="file"
                                accept="image/*,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv"
                                onChange={(e) => {
                                    const file = e.target.files?.[0] ?? null;
                                    setFiles((p) => ({ ...p, fileEventoDocumento: file }));
                                }}
                            />

                            {(form.rutaDocumento || files?.fileEventoDocumento) && (
                                <button
                                    type="button"
                                    className={styles["file-remove-icon"]}
                                    onClick={() => {
                                        setField("rutaDocumento", "");
                                        setFiles((p) => ({ ...p, fileEventoDocumento: null }));
                                    }}
                                >
                                    Quitar del formulario
                                </button>
                            )}
                        </div>
                    </div>

                    {files?.fileEventoDocumento?.name && (
                        <div className={styles["file-meta"]}>
                            Archivo seleccionado: {files.fileEventoDocumento.name}
                        </div>
                    )}

                    {form.rutaDocumento && (
                        <div className={styles["file-meta"]}>
                            <a href={form.rutaDocumento} target="_blank" rel="noreferrer">
                                Ver archivo subido
                            </a>
                        </div>
                    )}

                    <EnlacesField
                        value={form.enlaces}
                        onChange={(enlaces) => setField("enlaces", enlaces)}
                    />
                </Field>
            </div>
        </Section>
    );
}
